import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import axios from 'axios';
import { usePortfolioAuth } from '@/context/PortfolioAuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function GoogleOAuthHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = usePortfolioAuth();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state');

    // Check if this is a Google OAuth callback
    if (code && state === 'google_oauth') {
      handleGoogleCallback(code);
    }
  }, [location]);

  const handleGoogleCallback = async (code) => {
    try {
      const formData = new FormData();
      formData.append('code', code);

      const response = await axios.post(`${API}/portfolio/auth/google/callback`, formData);

      if (response.data.status === 'role_required') {
        // Store user info and redirect to role selection
        sessionStorage.setItem('google_user_info', JSON.stringify(response.data.user_info));
        sessionStorage.setItem('google_auth_code', code);
        navigate('/portfolio/select-role');
      } else if (response.data.status === 'success') {
        login(response.data.token, response.data.user);
        toast.success('Login successful!');
        navigate('/portfolio');
      }
    } catch (error) {
      console.error('Google callback error:', error);
      toast.error(error.response?.data?.detail || 'Authentication failed');
      navigate('/portfolio/login');
    }
  };

  return null; // This component doesn't render anything
}
